{
  "title": "Arcane Weapon (UA)",
  "source": "Unearthed Arcana 60 - The Artificer Returns",
  "levelAndSchool": "1st-level transmutation",
  "level": 1,
  "castingTime": "1 bonus action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You channel arcane energy into one simple or martial weapon you’re holding, and choose one damage type: acid, cold, fire, lightning, poison, or thunder. Until the spell ends, you deal an extra 1d6 damage of the chosen type to any target you hit with the weapon. If the weapon isn’t magical, it becomes a magic weapon for the spell’s duration.",
    "As a bonus action, you can change the damage type, choosing from the options above.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, you can maintain your concentration on the spell for up to 8 hours."
  ],
  "spellLists": ["artificer"]
}
